<template>
  <div>
  <el-dialog title="字典分类"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="500px">

    <el-button class="margin-bottom-10" @click="doAdd()" size="small"><i class="fa fa-plus"></i> 添加分类</el-button>

    <el-table class="list-table" :data="categories" border :stripe="true" style="width: 100%"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
      <template slot="empty">
        <div class="no-data">暂无数据！</div>
      </template>
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="类型名称" min-width="120"></el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click ="doAdd(scope.row)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
          <el-button type="text" @click.prevent="doRemove(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div slot="footer">
      <el-button @click="doClose" size="small"><i class="fa fa-close"></i> 关闭</el-button>
    </div>
  </el-dialog>


  <el-dialog :title="isEdit?'分类编辑':'字典添加'"
             :visible.sync="addDialog"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="400px">
    <el-form class="widget-form" :model="dictionary" label-width="80px" size="medium">

      <el-form-item label="维度名称:">
        <el-input type="text" v-model="dictionary.name" placeholder="请输入维度名称"></el-input>
      </el-form-item>

    </el-form>


    <div slot="footer" class="text-align-reverse">
      <el-button @click="addDialog = false" size="small"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="submit()" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>



  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { saveCategory, updateCategory,removeCategory, findCategory } from '@/api/rep/dictionary'
import { handleConfirm } from '@utils/confirm'

export default {
  computed: {
    ...mapGetters(['user', 'company']),
  },
  props: {
    visible: false,
    dictionaryId: null
  },
  data: function() {
    return {
      addDialog: false,
      isEdit: false,
      dictionary: {
        name:''
      },
      categories: []
    }
  },
  methods: {
    init() {
      this.findCategory()
    },
    doRemove(val) {
      handleConfirm('此操作将永久删除该分类，且相关的维度也会级联删除, 是否继续?').then(() => {
        removeCategory(val).then(resp => {
          this.$message.success(resp.data.message)
          this.findCategory()
        })
      })
    },
    doAdd(data) {
      this.addDialog = true
      if(data){
        this.isEdit = true
        this.dictionary = data
      }else{
        this.isEdit = false
        this.dictionary = { }
      }
    },
    findCategory() {
      findCategory().then(resp => {
        this.categories = resp.data.result
      })
    },
    doClose() {
      this.$emit('done', false)
    },
    submit() {
      if (this.dictionary.name) {
        if(this.isEdit){
          updateCategory(this.dictionary).then(res => {
            this.findCategory()
          })
        }else{
          saveCategory(this.dictionary).then(res => {
            this.findCategory()
          })
        }

        this.addDialog = false
      } else {
        this.$message.warning('请输入分类名称');
      }
    }

  }
}
</script>
<style lang="scss" scoped>
.sign {
  font-weight: bold;

  &:before {
    content: ' ';
    border-right: 4px solid #4381e6;
    margin-right: 8px;
  }
}
</style>
